import React, { Component } from "react"
export default class EmptyLayout extends Component{

   render(){

        return (
            <>
                {this.props.children}
            </>
        )

   }
}